var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg4UpIcon = function Svg4UpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0H25v23H3.5A3.5 3.5 0 0 1 0 19.5v-16A3.5 3.5 0 0 1 3.5 0z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#91E7A2",
    d: "M13.25 12.25H25V23H13.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.25h11.75V23H3.5A3.5 3.5 0 0 1 0 19.5v-7.25z",
    fill: "#FFC1EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC89C",
    d: "M13.25 0H25v10.75H13.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0h8.25v10.75H0V3.5A3.5 3.5 0 0 1 3.5 0z",
    fill: "#80E0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9h3.446C14.304 9 15 9.696 15 10.554v1.892c0 .858-.696 1.554-1.554 1.554h-1.892A1.554 1.554 0 0 1 10 12.446V9z",
    fill: "#FFF"
  })));
};

export default Svg4UpIcon;